export default function isJsonString(str) {
  if (typeof str !== 'string') return false;

  str = str.trim();

  if (typeof str === 'string' && (str[0] === '"' || str[str.length] === '"')) {
    return false;
  }

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};
